// Module
var code = "<a ng-transclude ng-href=\"{{ $ctrl.name | goUrl }}\" target=_blank> </a> ";
// Exports
module.exports = code;